import '../../styles/blocks/_welcome-card.scss';
import '../../styles/blocks/_blowup-modal.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import { Modal } from 'react-bootstrap';
import { formatText, FormattedText } from 'core/i18n';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import preLoaderActions from 'actions/preLoaderActions';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import UtagHelper from 'utilities/utagHelper';
import { RELIABLE } from 'utilities/uTagging';
import {
    PATH_CONTACT_WELCOME_CARD,
    PATH_PROFESSION_WELCOME_CARD,
    PATH_DEPOSIT_CONFIG_WELCOME_CARD,
    PATH_IDENTITY_WELCOME_CARD,
    PATH_CONTRACT_WELCOME_CARD,
    PATH_SIGNATURE_KEY_WELCOME_CARD,
    PATH_DOCUMENTATION_WELCOME_CARD,
    PATH_DOCUMENTATION_FINISHED_WELCOME_CARD,
    PATH_CONFIG_CARD_WELCOME_CARD,
    PATH_CREDIT_CARD_WELCOME_CARD,
    PATH_ROBO_INVESTMENT_PLAN_WELCOME_CARD,
    PATH_ROBO_TI_WECOME_CARD,
    PATH_CREDIT_CARD_INFO_WELCOME_CARD,
    PATH_TRANSFER_VERIFICATION_WELCOME_CARD,
    PATH_SELECT_CARD_WECOME_CARD,
    PATH_DOCUMENTATION_RETRY,
} from 'constants/uTagConstants/paths';
import { checkDocumentationCompleted } from 'utilities/documentationOptions/documentationOptions.js';
import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { DEFAULT_STEPS, CONFIG_CARD_STEPS, ROBO_STEPS, CREDIT_CARD_STEPS, DEPOSIT_STEPS } from 'constants/steps';
import { STAND_BY, LIMIT_CREDIT, DOCUMENTATION } from 'constants/statusProcess';
import { IBAN } from 'constants/identityMethod';
import { DEBIT_CARD } from 'constants/statusProcess';
import cryptoJS from 'crypto-js';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { CREDIT_CARD } from 'constants/userProfile';
import { getGA4EventKeys } from 'utilities/ga4';

class welcomeCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blowupClass: 'blowup-modal blowup-in',
        };

        this.handleShowWelcomeModal = this.handleShowWelcomeModal.bind(this);
        this.handleHideWelcomeModal = this.handleHideWelcomeModal.bind(this);
        this.getModalText = this.getModalText.bind(this);
        this.getSubtitle = this.getSubtitle.bind(this);
        this.taggingPage = this.taggingPage.bind(this);
        this.handleBlowupClass = this.handleBlowupClass.bind(this);
    }

    componentDidMount() {
        const { immStepsState } = this.props;
        const welcomeCard = immStepsState.get('welcomeCard');

        if (welcomeCard) {
            this.handleShowWelcomeModal();
            this.taggingPage();
        }
    }

    handleShowWelcomeModal() {
        this.setState({
            blowupClass: 'blowup-modal blowup-in',
        });
    }

    handleHideWelcomeModal() {
        this.props.actions.hideWelcomeCard();
    }

    handleBlowupClass() {
        this.setState({ blowupClass: 'blowup-modal blowup-out' });
        setTimeout(() => {
            this.handleHideWelcomeModal();
        }, 200);
    }

    taggingPage() {
        const { userProfile, immStepsState, products, documentation, recordAndSavePage } = this.props;
        const status = userProfile.status;
        const currentStep = immStepsState.get('currentStep') + 1;
        const steps = immStepsState.get('steps').toJS();
        const lastStep = steps.size;
        const wizardSelected = immStepsState.get('wizardSelected');
        const userDocumentation = documentation.get('filesToUpload');

        const { isMatchAnyIdDocuments, isMatchAnyExtraDocuments } = checkDocumentationCompleted(userDocumentation);
        const isMatchLowRiskVideoIdentified =
            (isMatchAnyIdDocuments && !isMatchAnyExtraDocuments) || documentation.size === 2;
        const isVideoIdentified =
            userProfile.identityMethod === VIDEO_CALL || userProfile.identityMethod === VIDEO_SELFIE;

        const hasUserUploadedDocumentation = userProfile.documentationUploaded;
        const isUserInStandBy = status === STAND_BY;
        const isUserLimitCredit = status === LIMIT_CREDIT;

        const isRoboSteps = wizardSelected === ROBO_STEPS;
        const isConfigCardSteps = wizardSelected === CONFIG_CARD_STEPS;
        const isTraditionalSteps = wizardSelected === DEFAULT_STEPS;
        const isDepositSteps = wizardSelected === DEPOSIT_STEPS;
        const isCreditCardSteps = wizardSelected === CREDIT_CARD_STEPS;
        const hasUploadedDocumentationOrStandby = hasUserUploadedDocumentation || isUserInStandBy;
        const isDebitCardStatus = userProfile.status === DEBIT_CARD;
        const isStandBy = userProfile.status === STAND_BY;
        const documentationUploaded =
            userProfile && (userProfile.documentationUploaded || isStandBy || userProfile.documentationUploadCompleted);
        let path;
        let detalleProceso;
        let tipoProceso;
        let pasoProceso;
        let customData = {};
        const pageNameByPathMapper = {
            [PATH_CONTACT_WELCOME_CARD]: 'personalData',
            [PATH_PROFESSION_WELCOME_CARD]: 'activity',
            [PATH_DEPOSIT_CONFIG_WELCOME_CARD]: 'depositConfiguration',
            [PATH_SELECT_CARD_WECOME_CARD]: 'cardSelection',
            [PATH_SIGNATURE_KEY_WELCOME_CARD]: 'signatureKey',
            [PATH_IDENTITY_WELCOME_CARD]: 'identityIban',
            [PATH_CONTRACT_WELCOME_CARD]: 'contract',
            [PATH_DOCUMENTATION_WELCOME_CARD]: 'documentationqr',
            [PATH_DOCUMENTATION_FINISHED_WELCOME_CARD]: 'documentationFinished',
            [PATH_ROBO_INVESTMENT_PLAN_WELCOME_CARD]: 'investmentPlan',
        };
        const eventNameByPath = {
            [PATH_CONTACT_WELCOME_CARD]: 'personal_data',
            [PATH_PROFESSION_WELCOME_CARD]: 'activity',
            [PATH_DEPOSIT_CONFIG_WELCOME_CARD]: 'deposit_configuration',
            [PATH_SELECT_CARD_WECOME_CARD]: 'card_selection',
            [PATH_SIGNATURE_KEY_WELCOME_CARD]: 'signatureKey',
            [PATH_IDENTITY_WELCOME_CARD]: 'identity',
            [PATH_CONTRACT_WELCOME_CARD]: 'contract',
            [PATH_DOCUMENTATION_WELCOME_CARD]: 'documentation',
            [PATH_DOCUMENTATION_FINISHED_WELCOME_CARD]: 'documentation_finished',
            [PATH_ROBO_INVESTMENT_PLAN_WELCOME_CARD]: 'investment_plan',
        };

        switch (currentStep) {
            case 1:
                path = PATH_CONTACT_WELCOME_CARD;
                break;
            case 2:
                path = PATH_PROFESSION_WELCOME_CARD;
                if (isDepositSteps) path = PATH_DEPOSIT_CONFIG_WELCOME_CARD;
                if (isConfigCardSteps) path = PATH_CONFIG_CARD_WELCOME_CARD;
                if (isDebitCardStatus) path = PATH_SELECT_CARD_WECOME_CARD;
                if (isRoboSteps) path = PATH_ROBO_TI_WECOME_CARD;
                break;

            case 3:
                path = PATH_SIGNATURE_KEY_WELCOME_CARD;
                if (isTraditionalSteps || isCreditCardSteps) path = PATH_IDENTITY_WELCOME_CARD;
                if (isConfigCardSteps || isDepositSteps) path = PATH_PROFESSION_WELCOME_CARD;
                if (isDebitCardStatus) path = PATH_SELECT_CARD_WECOME_CARD;
                if (isRoboSteps) path = PATH_ROBO_INVESTMENT_PLAN_WELCOME_CARD;
                break;

            case 4:
                path = PATH_DOCUMENTATION_WELCOME_CARD;
                if (isTraditionalSteps) path = PATH_SIGNATURE_KEY_WELCOME_CARD;
                if (isRoboSteps) path = PATH_PROFESSION_WELCOME_CARD;
                if (isCreditCardSteps && !isUserLimitCredit) path = PATH_CREDIT_CARD_WELCOME_CARD;
                if (isCreditCardSteps && isUserLimitCredit) path = PATH_CREDIT_CARD_INFO_WELCOME_CARD;
                if (isConfigCardSteps || isDepositSteps) path = PATH_IDENTITY_WELCOME_CARD;
                if (!isTraditionalSteps && hasUploadedDocumentationOrStandby)
                    path = PATH_DOCUMENTATION_FINISHED_WELCOME_CARD;
                if (status === DOCUMENTATION && !documentationUploaded && userProfile.documentationStatusCounter > 0) {
                    path = PATH_DOCUMENTATION_RETRY;
                    detalleProceso = 'revision';
                }
                break;
            case 5:
                path = PATH_DOCUMENTATION_WELCOME_CARD;
                if (isTraditionalSteps) path = PATH_CONTRACT_WELCOME_CARD;

                if (isTraditionalSteps && hasUploadedDocumentationOrStandby)
                    path = PATH_DOCUMENTATION_FINISHED_WELCOME_CARD;
                if (isCreditCardSteps || isRoboSteps || isConfigCardSteps || isDepositSteps)
                    path = PATH_SIGNATURE_KEY_WELCOME_CARD;
                detalleProceso = 'card-bienvenida';
                if (isUserInStandBy && userProfile.identityMethod === IBAN)
                    detalleProceso = 'finalizado-otp/card-bienvenida';
                tipoProceso = 'onboarding';
                pasoProceso = 'documentacion';
                if (status === DOCUMENTATION && !documentationUploaded && userProfile.documentationStatusCounter > 0) {
                    path = PATH_DOCUMENTATION_RETRY;
                    detalleProceso = 'revision';
                }
                break;

            case 6:
                path = PATH_DOCUMENTATION_WELCOME_CARD;
                if (isTraditionalSteps) path = PATH_DOCUMENTATION_WELCOME_CARD;
                if (isRoboSteps || isCreditCardSteps || isDepositSteps) path = PATH_CONTRACT_WELCOME_CARD;
                if (
                    hasUploadedDocumentationOrStandby ||
                    (isVideoIdentified && isMatchLowRiskVideoIdentified && !isCreditCardSteps)
                )
                    path = PATH_DOCUMENTATION_FINISHED_WELCOME_CARD;
                if (status === DOCUMENTATION && !documentationUploaded && userProfile.documentationStatusCounter > 0) {
                    path = PATH_DOCUMENTATION_RETRY;
                    detalleProceso = 'revision';
                }

                break;

            case 7:
                path = PATH_DOCUMENTATION_WELCOME_CARD;
                if (isTraditionalSteps) path = PATH_TRANSFER_VERIFICATION_WELCOME_CARD;
                if (isCreditCardSteps || isDepositSteps) path = PATH_DOCUMENTATION_WELCOME_CARD;
                if (isRoboSteps) path = PATH_IDENTITY_WELCOME_CARD;
                if (
                    hasUploadedDocumentationOrStandby ||
                    (isVideoIdentified && isMatchLowRiskVideoIdentified && !isCreditCardSteps && !isDepositSteps)
                )
                    path = PATH_DOCUMENTATION_FINISHED_WELCOME_CARD;
                if (status === DOCUMENTATION && !documentationUploaded && userProfile.documentationStatusCounter > 0) {
                    path = PATH_DOCUMENTATION_RETRY;
                    detalleProceso = 'revision';
                }
                break;
            case 8:
                path = '/onbaording/step8/documentationqr/welcome-card';
                customData = {
                    pageName: 'onboarding/step8/documentationqr/welcome-card',
                    processStep: 'step8',
                    processDetail: 'documentationqr/welcome-card',
                };
                if (isRoboSteps) path = PATH_DOCUMENTATION_WELCOME_CARD;
                if (isRoboSteps && (hasUserUploadedDocumentation || isUserInStandBy))
                    path = PATH_DOCUMENTATION_FINISHED_WELCOME_CARD;
                if (isDepositSteps || isCreditCardSteps) path = PATH_TRANSFER_VERIFICATION_WELCOME_CARD;
                if (currentStep === lastStep && isUserInStandBy)
                    customData.pageName = '/onboarding/standBy/welcome-card';
                break;
            case 9:
                if (isRoboSteps) path = PATH_TRANSFER_VERIFICATION_WELCOME_CARD;
                break;
            default:
                path = '';
                break;
        }

        const id = setTimeout(() => {
            const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
            const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
            const pageNameByPath =
                userProfile.status === STAND_BY && path === PATH_DOCUMENTATION_FINISHED_WELCOME_CARD
                    ? STAND_BY
                    : pageNameByPathMapper[path];

            recordAndSavePage(
                path,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                JointHolderInfo,
                userProfile.identityMethod ? RELIABLE[userProfile.identityMethod] : '',
                '',
                userProfile.investmentType,
                {
                    detalleProceso,
                    pasoProceso,
                    tipoProceso,
                    identificadorOnboarding: docNumberEncrypted,
                    nombreProducto:
                        userProfile.investmentType === CREDIT_CARD
                            ? `${userProfile.productType}.${userProfile.productSubtype}.${userProfile.productStandard}`
                            : '',
                    devId: '1welcomeCard',
                    onboardingR: userProfile.clientRisk || '',
                    onboardingIdMethod: RELIABLE[userProfile.identityMethod] || '',
                    processStep: `step${currentStep}`,
                    processDetail: `${pageNameByPathMapper[path]}/welcome-card`,
                    onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
                    ...getGA4EventKeys({
                        eventName: `step_${eventNameByPath[path]}`,
                        pageName: `/onboarding/step${currentStep}/${pageNameByPath}/welcome-card`,
                        processDetail: `${pageNameByPathMapper[path]}/welcome-card`,
                        onboardingType: userProfile.investmentType,
                        typeHolder: userProfile.typeHolder,
                    }),
                    ...customData,
                }
            );
            clearTimeout(id);
        }, 2500);
    }

    getCurrentAndLastStep = () => {
        const { immStepsState, flags } = this.props;
        const steps = immStepsState.get('steps').toJS();
        const currentStepKey = immStepsState.get('currentStep') + 1;
        const isStepAvailable = ({ flagControl }) => (flagControl ? flags.get(flagControl) : true);

        const availableSteps = steps.filter(isStepAvailable);
        const disabledStepsBeforeCurrentStepKey = steps.filter(step => {
            return step.key < currentStepKey && !isStepAvailable(step);
        });

        const calculatedStepByDisabledSteps = currentStepKey - disabledStepsBeforeCurrentStepKey.length;

        return [calculatedStepByDisabledSteps, availableSteps.length];
    };

    getModalText() {
        const { userProfile, immStepsState } = this.props;
        const currentStep = immStepsState.get('currentStep') + 1;
        const wizardSelected = immStepsState.get('wizardSelected');

        const hasUserUploadedDocumentation = userProfile && userProfile.documentationUploaded;
        const isUserInStandBy = userProfile && userProfile.status === STAND_BY;
        const isRoboSteps = wizardSelected === ROBO_STEPS;
        const isConfigCardSteps = wizardSelected === CONFIG_CARD_STEPS;
        const isTraditionalSteps = wizardSelected === DEFAULT_STEPS;
        const isCreditCardSteps = wizardSelected === CREDIT_CARD_STEPS;
        const isDepositSteps = wizardSelected === DEPOSIT_STEPS;
        const isDebitCardStatus = userProfile.status === DEBIT_CARD;
        const currentAndLastStep = this.getCurrentAndLastStep();

        const personalInfoText = (
            <FormattedText value="welcomeCard-continueStep1" injectedStrings={currentAndLastStep} />
        );
        const otpTransferText = (
            <FormattedText value="welcomeCard-otpTransferStep" injectedStrings={currentAndLastStep} />
        );
        const professionalInfoText = (
            <FormattedText value="welcomeCard-continueStep2" injectedStrings={currentAndLastStep} />
        );
        const identifyInfoText = (
            <FormattedText value="welcomeCard-continueStep3" injectedStrings={currentAndLastStep} />
        );
        const signingInfoText = (
            <FormattedText value="welcomeCard-continueStep4" injectedStrings={currentAndLastStep} />
        );
        const documentationInfoText = (
            <FormattedText value="welcomeCard-continueStep5" injectedStrings={currentAndLastStep} />
        );
        const creditCardInfoText = (
            <FormattedText value="welcomeCard-continueStepConfigCreditCard" injectedStrings={currentAndLastStep} />
        );
        const configCardInfoText = (
            <FormattedText value="welcomeCard-continueStepCard" injectedStrings={currentAndLastStep} />
        );
        const depositConfigInfoText = (
            <FormattedText value="welcomeCard-continueStepDeposit" injectedStrings={currentAndLastStep} />
        );
        const suitabilityTestInfoText = (
            <FormattedText value="welcomeCard-continueStepSuitabilityTest" injectedStrings={currentAndLastStep} />
        );
        const investmentStrategyInfoText = (
            <FormattedText value="welcomeCard-continueStepInvestmentStrategy" injectedStrings={currentAndLastStep} />
        );
        const selectDesignCardText = (
            <FormattedText value="welcomeCard-continueStepCard" injectedStrings={currentAndLastStep} />
        );
        const signatureKeyStepText = (
            <FormattedText value="welcomeCard-continueStepSignatureKey" injectedStrings={currentAndLastStep} />
        );

        const standByInfoText = formatText('welcomeCard-standBy');

        let modalText;

        switch (currentStep) {
            case 1:
                modalText = personalInfoText;
                break;
            case 2:
                modalText = professionalInfoText;
                if (isConfigCardSteps) modalText = configCardInfoText;
                if (isDepositSteps) modalText = depositConfigInfoText;
                if (isRoboSteps) modalText = suitabilityTestInfoText;
                if (isDebitCardStatus) modalText = selectDesignCardText;
                break;
            case 3:
                modalText = signatureKeyStepText;
                if (isTraditionalSteps || isCreditCardSteps) modalText = identifyInfoText;
                if (isConfigCardSteps) modalText = professionalInfoText;
                if (isDepositSteps) modalText = professionalInfoText;
                if (isDebitCardStatus) modalText = selectDesignCardText;
                if (isRoboSteps) modalText = investmentStrategyInfoText;
                break;
            case 4:
                modalText = documentationInfoText;
                if (isTraditionalSteps) modalText = signatureKeyStepText;
                if (isCreditCardSteps) modalText = creditCardInfoText;
                if (isRoboSteps) modalText = professionalInfoText;
                if (isConfigCardSteps) modalText = identifyInfoText;
                if (isDepositSteps) modalText = identifyInfoText;
                if (!isCreditCardSteps && (hasUserUploadedDocumentation || isUserInStandBy))
                    modalText = standByInfoText;
                break;
            case 5:
                modalText = documentationInfoText;
                if (isCreditCardSteps || isRoboSteps || isConfigCardSteps || isDepositSteps)
                    modalText = signatureKeyStepText;
                if (hasUserUploadedDocumentation || isUserInStandBy) modalText = standByInfoText;
                if (isTraditionalSteps) modalText = signingInfoText;
                break;
            case 6:
                modalText = documentationInfoText;
                if (isTraditionalSteps) modalText = documentationInfoText;
                if (isRoboSteps || isCreditCardSteps) modalText = signingInfoText;
                if (hasUserUploadedDocumentation || isUserInStandBy) modalText = standByInfoText;
                if (isDepositSteps) modalText = signingInfoText;
                break;
            case 7:
                modalText = documentationInfoText;
                if (isTraditionalSteps) modalText = otpTransferText;
                if (isCreditCardSteps || isDepositSteps) modalText = documentationInfoText;
                if (isRoboSteps) modalText = identifyInfoText;
                break;
            case 8:
                if (isRoboSteps) modalText = documentationInfoText;
                if (isRoboSteps && (hasUserUploadedDocumentation || isUserInStandBy)) modalText = standByInfoText;
                if (isDepositSteps || isCreditCardSteps) modalText = otpTransferText;
                break;
            case 9:
                if (isRoboSteps) modalText = otpTransferText;
                break;
            default:
                modalText = 'title';
                break;
        }

        return modalText;
    }

    getSubtitle() {
        const { userProfile, immStepsState } = this.props;
        const currentStep = immStepsState.get('currentStep') + 1;
        const steps = immStepsState.get('steps');
        const lastStep = steps.size;
        let modalsubtitle = formatText('welcomeCard-activatingAccount');

        const hasUserUploadedDocumentation = userProfile && userProfile.documentationUploaded;
        const isUserInStandBy = userProfile && userProfile.status === STAND_BY;

        if (currentStep === lastStep && hasUserUploadedDocumentation)
            modalsubtitle = formatText('welcomeCard-finishingVerification');

        if (currentStep === lastStep && isUserInStandBy) {
            modalsubtitle = userProfile.isJointHolderAccount
                ? formatText('welcomeCard-finishingVerificationStandByJointHolder')
                : formatText('welcomeCard-finishingVerificationStandBy');
        }

        return modalsubtitle;
    }

    buildContinueModal() {
        const { userProfile, immStepsState } = this.props;
        const welcomeCard = immStepsState.get('welcomeCard');
        const modalText = this.getModalText();
        const modalsubtitle = this.getSubtitle();
        const modalClass = `welcome-modal overwritten-modal ${this.state.blowupClass}`;
        const isUserInStandBy = userProfile && userProfile.status === STAND_BY;

        const continueTitle = isUserInStandBy
            ? formatText('welcomeCard-newContinueModalTitle', [userProfile.name])
            : formatText('welcomeCard-continueModalTitle', [userProfile.name]);

        return (
            <div>
                <Modal
                    show={welcomeCard}
                    onHide={this.handleBlowupClass}
                    dialogClassName={modalClass}
                    backdrop="static"
                    keyboard={false}
                    animation={false}
                >
                    <Modal.Body>
                        <a
                            href="#"
                            onClick={event => {
                                event.preventDefault();
                                this.handleBlowupClass();
                            }}
                        >
                            <span className="icons--icon-close"></span>
                        </a>
                        <h3 className="font-heading3">{continueTitle}</h3>
                        <span className="dash" />
                        <div className="welcome-container">
                            <div className="icon-container">
                                <i className="icons icons--icon-handshake"></i>
                            </div>
                            <div className="text-container">
                                <h5 className="font-heading6">{modalsubtitle}</h5>
                                <p className="font-paragraph2">{modalText}</p>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    render() {
        const welcomeModal = this.buildContinueModal();

        return <div>{welcomeModal}</div>;
    }
}

module.exports.constructor = welcomeCard;
module.exports.welcomeCard = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        options: state.options,
        preLoader: state.preLoader,
        products: state.products,
        documentation: state.documentation,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(withFeatureToggling(welcomeCard));
